// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"PersistentInfoDialog_checkboxContainer__z9qdl","checkbox":"PersistentInfoDialog_checkbox__-AMPC","checkboxIcon":"PersistentInfoDialog_checkboxIcon__tQCMF"};